<script>
    import { Message } from 'element-ui';

    export default {
        name: 'temporary-password-expired',

        props: {
            message: {
                type: String,
                required: true
            },

            type: {
                type: String,
                required: true
            },

            duration: {
                type: Number,
                default: 3000
            }
        },

        mounted() {
            Message({
                type: this.type,
                message: this.message,
                duration: this.duration
            });
        }
    }
</script>